export function getLexiconLink(path: string[]) {
    return "/lexicon/" + path.join("/");
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/route-utils.ts